import * as React from "react";
import {RadialChart, DiscreteColorLegend} from 'react-vis';
import Panel from "../core/Panel";
import Loader from "../core/Loader";
import jfetch from "../../utils/jfetch";
import toast from "../../utils/toast";
import styled from "styled-components";

interface IProps {
}

interface IState {
  data: any,
  legendData: any,
  isLoading: boolean,
}


const EmptyDiv = styled.div`
  min-height: 342px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChartContainer = styled.div`
  min-width: 500px;
  min-height: 342px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NoteContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const colors = {
  Unenrolled: '#e4e8b2',
  InProgress: '#90DE9E',
  Completed: '70C7C0'
};

class CourseEnrollementChart extends React.Component<IProps, IState> {

  state: IState = {
    data: [],
    legendData: [],
    isLoading: false,
  };

  componentDidMount(): void {
    this.getCourseEnrollmentData();
  }

  getCourseEnrollmentData = async () => {
    this.setState({isLoading: true});
    try {
      const data = await jfetch.get(`users_enrolled_graph`);
      if (data.status === "ok") {
        const formattedData = this.formatChartData(data.data);
        this.setState({
          data: formattedData,
          isLoading: false
        });
      }
      this.formatChartLegendData(data.data);
    } catch (e) {
      toast.error("Error retrieving course views data");
    }
  }

  formatChartData = (data) => {
    const formattedData = data.map((e) => {
      return {
        angle: e.percentage,
        label: e.label,
        color: colors[e.label],
        padAngle: 1
      };
    });
    return formattedData;
  };

  formatChartLegendData = (data) => {
    const legendData = data.map((e) => {
      return { title: `${e.label}: ${e.percentage}%`, color: `${colors[e.label]}` };
    });
    this.setState({
      legendData: legendData
    });
  };

  render() {

    const {data, legendData, isLoading} = this.state;

    return (
      <Panel heading={"User Enrollments"}>
        {
          isLoading
            ? <EmptyDiv><Loader/></EmptyDiv>
            : (
              <>
                <ChartContainer>
                  <RadialChart
                    data={data}
                    colorType={"literal"}
                    showLabels
                    padAngle={0.02}
                    labelsRadiusMultiplier={1}
                    width={300}
                    height={300} />
                  <DiscreteColorLegend
                    items={legendData}
                  />
                </ChartContainer>
                <NoteContainer>
                  * Percentages based on all users
                </NoteContainer>
              </>
            )
        }
      </Panel>
    );
  }
}

export default CourseEnrollementChart;



// WEBPACK FOOTER //
// ./app/javascript/components/report/CourseEnrollementChart.tsx